import { useMemo } from 'react'
import { SorteeLandingSeo } from '../IndexPage/sorteeLanding/components/SorteeLandingSeo'
import { sorteeLandingSeo } from '../IndexPage/sorteeLanding/content/sorteeLandingContent'

export function MarketingSeo({
  title,
  description,
  path,
}: {
  title: string
  description: string
  path: string
}) {
  const content = useMemo(() => {
    const canonical = `https://sortee.io${path}`
    return {
      ...sorteeLandingSeo,
      browserTitle: `${title} | Sortee`,
      description,
      canonical,
      og: {
        ...sorteeLandingSeo.og,
        title: `${title} | Sortee`,
        description,
        url: canonical,
      },
      twitter: { ...sorteeLandingSeo.twitter, title: `${title} | Sortee`, description },
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: title,
        description,
        url: canonical,
        inLanguage: 'pt-BR',
        isPartOf: { '@type': 'WebSite', name: 'Sortee', url: 'https://sortee.io/' },
      },
    }
  }, [title, description, path])
  return <SorteeLandingSeo content={content} />
}
